import echarts from 'echarts';
import Store from '../../store';
import { deepCopy, generateRandomKey, insertNewChart } from '../../utils/chartUtil';
import { echartsEngine } from './utils/echartsEngine/index';

const ChartSetting = {
    currentChartIndex: 0,
    chartLists: []
}

/**
 * 
 * @param render 插入图表的容器
 * @param chartData 框选的数据
 * @param chart_id 图表ID
 * 返回容器/id/chart_json图表配置
 */
export function createChart(render, chartData, chart_id, rangeArray, rangeTxt) {

    let chart_Id = chart_id ? chart_id : generateRandomKey('chart')
    render.id = chart_Id

    chartOptions.defaultOption.series = []

    // 随机生成图表
    let ratio = Math.random() * 10
    if (ratio > 5) {
        chartOptions.chartAllType = 'echarts|pie|default'
    } else {
        chartOptions.chartAllType = 'echarts|line|default'
    }

    // 生成图表数据结构
    let chartOption = insertNewChart(chartOptions, chart_Id, chartOptions.chartAllType, chartData, rangeArray, rangeTxt)

    let renderDom = document.createElement('div')
    renderDom.id = 'render' + chart_Id
    render.appendChild(renderDom)
    console.warn('chart render', Store.zoomRatio, renderDom);

    let chart_json = {
        'chart_id': chart_Id,
        'active': true,
        'chartOptions': deepCopy(chartOption)
    }

    ChartSetting.currentChartIndex = ChartSetting.chartLists.length
    ChartSetting.chartLists.push(chart_json)

    const chartJson = ChartSetting.chartLists.find(item => item.chart_id == this.chart_Id)

    let _chartOptions = null;
    let _active = false;

    if(chartJson) {
       _chartOptions = chartJson.chartOptions;
       _active = chartJson.active;
    }

    renderChart(renderChartObj, )

    return {
        render,
        chart_Id,
        chart_json
    }
}

// highlight current chart
export function highlightChart(chart_id) {
    let index = ChartSetting.chartLists.findIndex(item => item.chart_id == chart_id)
    ChartSetting.currentChartIndex = index
    return ChartSetting.chartLists[ChartSetting.currentChartIndex].chartOptions
}

// resize chart
export function resizeChart(chart_id) {
    let index = ChartSetting.chartLists.findIndex(item => item.chart_id == chart_id)
    var chartAllType = ChartSetting.chartLists[index].chartOptions.chartAllType;
    const _chartEle = document.getElementById(`${chart_id}_c`);
    
    const xZoomRatio = Store.ch_width_zoomed / Store.ch_width_origin;
    const yZoomRatio = Store.rh_height_zoomed / Store.rh_height_origin;

    if(_chartEle && _chartEle.style.display !== 'none') {
        $(_chartEle).css('width', `${Store.chartOriginSize[chart_id].width * xZoomRatio}px`);
        $(_chartEle).css('height', `${Store.chartOriginSize[chart_id].height * yZoomRatio}px`);
        $(_chartEle).css('left', `${Store.chartOriginSize[chart_id].left * xZoomRatio}px`);
        $(_chartEle).css('top', `${Store.chartOriginSize[chart_id].top * yZoomRatio}px`);    
    }
    var chartAllTypeArray = chartAllType.split("|");
    var chartPro = chartAllTypeArray[0],
        chartType = chartAllTypeArray[1],
        chartStyle = chartAllTypeArray[2];

    if (chartPro == "echarts") {
        const _echartInstance = echarts.getInstanceById($("#" + chart_id).attr("_echarts_instance_"));
        _echartInstance && _echartInstance.resize();
    }
}

/**
 * 这里主要用于 zoom 变化时，调整 chart 容易大小
 */
export function resizeAllCharts() {
    const chartIds = ChartSetting.chartLists.map( e => e.chart_id);
    chartIds.forEach((cId) => {
        resizeChart(cId);
    })
}

export function getChartJson(chart_id) {
    let index = ChartSetting.chartLists.findIndex(item => item.chart_id == chart_id)
    return  ChartSetting.chartLists[index].chartOptions;
}

export function renderChart(renderChartObj) {
    let chartOptions = renderChartObj.chartOptions
    let chart_id = chartOptions.chart_id
    // const { chart_id, chartOptions } = renderChartObj;
    const chartAllTypeArray = chartOptions.chartAllType.split('|');
    const chartPro = chartAllTypeArray[0];
    // const container = ele || document.getElementById(chart_id);
    const container = document.getElementById(chart_id);
    if (chartPro === 'echarts') {
        const options = echartsEngine(chartOptions);

        let chart = echarts.getInstanceByDom(container);
        if (chart == null) {
            chart = echarts.init(container)
        }

        chart.setOption(options, true);

        setTimeout(() => {
            const _echartInstance = echarts.getInstanceById(container.getAttribute('_echarts_instance_'));
            _echartInstance && _echartInstance.resize();
        }, 0);
    }
}

export function insertToStore(chart_json){
    ChartSetting.chartLists.push(chart_json)
}